// Armed Forces and Police Service Skills organized by subcategories
export const ARMED_FORCES_POLICE_SKILLS_CATEGORIES = [
  {
    name: 'Combat Operations',
    skills: [
      'Tactical Planning', 'Weapons Proficiency', 'Combat Tactics',
      'Field Operations', 'Unit Coordination', 'Battle Strategy',
      'Mission Planning', 'Target Assessment', 'Combat Support',
      'Terrain Analysis', 'Combat Leadership', 'Team Coordination',
      'Battlefield Awareness', 'Combat Communication', 'Risk Assessment'
    ]
  },
  {
    name: 'Law Enforcement',
    skills: [
      'Criminal Law', 'Arrest Procedures', 'Evidence Handling',
      'Suspect Processing', 'Crime Scene Management', 'Public Safety',
      'Patrol Techniques', 'Traffic Control', 'Community Policing',
      'Investigation Methods', 'Report Writing', 'Court Procedures',
      'Legal Documentation', 'Conflict Resolution', 'Crisis Management'
    ]
  },
  {
    name: 'Physical Training',
    skills: [
      'Fitness Training', 'Combat Fitness', 'Strength Training',
      'Endurance Building', 'Agility Training', 'Self-Defense',
      'Hand-to-Hand Combat', 'Physical Assessment', 'Training Programs',
      'Recovery Methods', 'Injury Prevention', 'Performance Enhancement',
      'Team Training', 'Tactical Movement', 'Combat Athletics'
    ]
  },
  {
    name: 'Weapons Training',
    skills: [
      'Firearms Proficiency', 'Weapon Maintenance', 'Marksmanship',
      'Range Operations', 'Weapon Safety', 'Combat Shooting',
      'Tactical Reloading', 'Weapon Systems', 'Ammunition Management',
      'Target Practice', 'Qualification Standards', 'Training Methods',
      'Equipment Care', 'Safety Protocols', 'Performance Assessment'
    ]
  },
  {
    name: 'Intelligence Operations',
    skills: [
      'Intelligence Gathering', 'Data Analysis', 'Surveillance',
      'Counter-Intelligence', 'Information Security', 'Target Analysis',
      'Threat Assessment', 'Intelligence Reports', 'Source Management',
      'Data Protection', 'Network Security', 'Intelligence Sharing',
      'Risk Analysis', 'Strategic Planning', 'Operational Security'
    ]
  },
  {
    name: 'Security Management',
    skills: [
      'Access Control', 'Perimeter Security', 'Security Planning',
      'Threat Response', 'Security Systems', 'Personnel Security',
      'Asset Protection', 'Risk Management', 'Emergency Response',
      'Security Assessment', 'Protocol Development', 'Team Leadership',
      'Crisis Management', 'Security Training', 'Compliance'
    ]
  },
  {
    name: 'Investigation Skills',
    skills: [
      'Crime Scene Analysis', 'Evidence Collection', 'Witness Interviews',
      'Case Management', 'Forensic Methods', 'Documentation',
      'Report Writing', 'Legal Procedures', 'Digital Forensics',
      'Background Checks', 'Surveillance', 'Intelligence Gathering',
      'Data Analysis', 'Criminal Profiling', 'Court Testimony'
    ]
  },
  {
    name: 'Emergency Response',
    skills: [
      'Crisis Management', 'First Response', 'Emergency Planning',
      'Disaster Response', 'Medical Aid', 'Evacuation',
      'Search and Rescue', 'Incident Command', 'Team Coordination',
      'Resource Management', 'Communication', 'Risk Assessment',
      'Public Safety', 'Documentation', 'After-Action Review'
    ]
  },
  {
    name: 'Leadership Skills',
    skills: [
      'Team Leadership', 'Command Structure', 'Decision Making',
      'Strategic Planning', 'Personnel Management', 'Training Programs',
      'Performance Assessment', 'Motivation', 'Team Building',
      'Crisis Leadership', 'Communication', 'Resource Management',
      'Problem Solving', 'Conflict Resolution', 'Mentoring'
    ]
  },
  {
    name: 'Communication Skills',
    skills: [
      'Radio Operations', 'Clear Communication', 'Chain of Command',
      'Report Writing', 'Briefing Skills', 'Public Relations',
      'Team Communication', 'Crisis Communication', 'Documentation',
      'Information Sharing', 'Media Relations', 'Community Engagement',
      'Internal Communication', 'Protocol Adherence', 'Emergency Communication'
    ]
  },
  {
    name: 'Technology Skills',
    skills: [
      'Computer Systems', 'Security Software', 'Communication Systems',
      'Surveillance Equipment', 'Data Management', 'Digital Evidence',
      'System Operations', 'Equipment Maintenance', 'Technology Integration',
      'Cybersecurity', 'Database Management', 'Software Applications',
      'System Updates', 'Technical Support', 'Equipment Training'
    ]
  },
  {
    name: 'Legal Knowledge',
    skills: [
      'Criminal Law', 'Constitutional Law', 'Legal Procedures',
      'Evidence Law', 'Court Systems', 'Legal Rights',
      'Search and Seizure', 'Use of Force', 'Legal Documentation',
      'Testimony', 'Case Law', 'Regulatory Compliance',
      'Legal Updates', 'Policy Knowledge', 'Ethics Standards'
    ]
  },
  {
    name: 'Tactical Operations',
    skills: [
      'Tactical Planning', 'Team Coordination', 'Entry Techniques',
      'Room Clearing', 'Building Search', 'Vehicle Operations',
      'Tactical Movement', 'Cover and Concealment', 'Night Operations',
      'Urban Operations', 'Rural Operations', 'Special Weapons',
      'Team Tactics', 'Risk Assessment', 'Mission Planning'
    ]
  },
  {
    name: 'Public Safety',
    skills: [
      'Community Relations', 'Public Protection', 'Crime Prevention',
      'Safety Education', 'Emergency Response', 'Public Communication',
      'Risk Management', 'Safety Planning', 'Community Engagement',
      'Crisis Management', 'Safety Assessment', 'Public Information',
      'Emergency Planning', 'Safety Training', 'Incident Response'
    ]
  },
  {
    name: 'Equipment Management',
    skills: [
      'Inventory Control', 'Maintenance', 'Equipment Issue',
      'Quality Control', 'Safety Inspection', 'Repair Procedures',
      'Supply Management', 'Equipment Training', 'Documentation',
      'Asset Tracking', 'Budget Management', 'Equipment Planning',
      'Performance Testing', 'Safety Standards', 'Equipment Updates'
    ]
  },
  {
    name: 'Training Management',
    skills: [
      'Program Development', 'Training Delivery', 'Skills Assessment',
      'Certification', 'Training Records', 'Course Design',
      'Instructor Skills', 'Performance Evaluation', 'Training Plans',
      'Resource Management', 'Quality Control', 'Safety Standards',
      'Documentation', 'Program Assessment', 'Continuous Improvement'
    ]
  },
  {
    name: 'Administrative Skills',
    skills: [
      'Records Management', 'Documentation', 'Report Writing',
      'Data Entry', 'File Management', 'Budget Control',
      'Resource Planning', 'Schedule Management', 'Personnel Records',
      'Compliance', 'Policy Implementation', 'Quality Control',
      'Process Improvement', 'Administrative Support', 'Office Management'
    ]
  },
  {
    name: 'Special Operations',
    skills: [
      'Advanced Tactics', 'Specialized Training', 'Mission Planning',
      'Team Leadership', 'Risk Assessment', 'Advanced Equipment',
      'Special Weapons', 'Tactical Planning', 'Team Coordination',
      'Crisis Response', 'Intelligence Operations', 'Advanced Communication',
      'Special Skills', 'Performance Standards', 'Mission Success'
    ]
  },
  {
    name: 'International Operations',
    skills: [
      'Cultural Awareness', 'Language Skills', 'International Law',
      'Diplomatic Relations', 'Cross-Border Operations', 'International Cooperation',
      'Protocol Knowledge', 'Cultural Sensitivity', 'International Standards',
      'Joint Operations', 'Communication Skills', 'Risk Management',
      'Security Protocols', 'Documentation', 'Relationship Building'
    ]
  },
  {
    name: 'Professional Development',
    skills: [
      'Career Planning', 'Skill Enhancement', 'Leadership Development',
      'Advanced Training', 'Certification', 'Specialization',
      'Continuing Education', 'Professional Standards', 'Performance Goals',
      'Mentoring', 'Career Advancement', 'Professional Growth',
      'Knowledge Management', 'Skill Assessment', 'Development Planning'
    ]
  }
];

// Export flattened list for backward compatibility
export const ARMED_FORCES_POLICE_SKILLS = ARMED_FORCES_POLICE_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
